//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================
import { makeStyles } from "@material-ui/core/styles";

export const sidebarStyles = makeStyles((theme) => ({
    component: {
        display: "flex",
        flexFlow: "column",
        borderRadius: 50,
        padding: "10px 20px",
        marginBottom: 20,
        "@media (max-width: 600px)": {
            height: "100%",
        },
        "@media (max-width: 768px)": {
            display: "none",
        },
    },
    Link: {
        color: "#707070",
        textDecoration: "none",
    },
    highLight: {
        backgroundColor: "#eaf2f8",
        color: "#2F7CBD",
        borderRadius: 10,
        "&:hover": {
            background: "#eaf2f8",
        },
    },
    icon: {
        color: "#2F7CBD",
    },
    sideBarStyle: {
        fontFamily: "Segoe-ui !important",
        fontSize: "0.875rem",
    },
    sidebarHeader: {
        background: "#f6f9fc",
        borderRadius: 15,
        minHeight: 110,
        padding: "10px 10px 10px 0px",
        marginBottom: 10,
    },
      sidebarHeaderUnlock: {
    background: "#0A72BA",
    borderRadius: 15,
    minHeight: 110,
    padding: "0px 10px 10px 0px",
    marginBottom: 10,
    width: "auto", // Define width ONLY here
    boxSizing: "border-box",// Ensures padding doesn't break the 330px constraint
},
    sidebarHeaderTxtUnlock: {
        color: "#FFFFFF",
        fontWeight: 900,
        lineHeight: 1.3
    },

customerNameUnlock: {
    color: "#000",
    fontWeight: "bold",
    lineHeight: 1.1,
    fontSize: 18,
    padding: 10,
    background: "#FFFFFF",
    border: "2px solid #0A72BA",
    borderRadius: "15px 15px 0px 0px",
    
    // FIXES FOR ZOOM COMPATIBILITY:
    width: "auto", // Let it naturally fill the parent's width
    boxSizing: "border-box", // Includes the 2px border inside the width calculation
    marginRight: "-10px" // Negative margin offsets the parent's right padding perfectly!
},
    customerName: {
        color: "black",
        fontWeight: "bold",
        lineHeight: 1.1,
        fontSize: 18,
        marginBottom: 10,
    },
    sidebarHeaderTxt: {
        color: "#000",
        fontWeight: 900,
        lineHeight: 1.3
    },    
    sidebarItemActive: {
        backgroundColor: " #0a72ba !important",
        color: "#fff!important",
        paddingLeft: "10px !important",
        textTransform: "uppercase",
        textAlign: "left",
    },
    listItem: {
        paddingLeft: "10px !important",
        background: "#fff !important",
        color: "#000 !important",
        borderBottom: "1px solid #e4e4e4",
        borderRight: "1px solid #e4e4e4",
        borderLeft: "1px solid #e4e4e4",
        textAlign: "left",
    },
    listItemTxt: {
        whiteSpace: "nowrap",
        fontWeight: "bold",
    },
    sidebarHeaderForMobile: {
        background: "#f6f9fc",
        borderRadius: 15,
        minHeight: 110,
        padding: 10,
        marginBottom: 10,
        display: "none",
        "@media (max-width: 768px)": {
            display: "block",
            width: "90%",
            margin: "10px auto",
        },
    },
    tierImg: {
        minWidth: 60,
        maxWidth: 110,
        objectFit: 'contain',
        // margin: "18px"
       
    },

    tierImgnew: {
        minWidth: 60,
        maxWidth: 110,
        objectFit: 'contain',
        margin: "18px"
    },
    tierName: {
        position: "absolute",
        top: "32%", 
        left: "30%",
        "@media (min-width: 1400px)":{            
            left: "21%",
            top: "30%"
        },
        
    },
    changeLoyaltyBtn: {
        textDecoration: "underline",
        color: "#0a72ba",
        cursor: "pointer",
        fontSise: 12
    },
    changeLoyaltyBtnUnlock: {
        textDecoration: "underline",
        color: "#FFFFFF",
        cursor: "pointer",
        fontSise: 12
    },
    signatureend: {
        color: "#FF0000",       
        
    },
}));